/**
 * @generated SignedSource<<ff32447f6f6a3d7dbbd91560065dad22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraFormattingArea = "CELL" | "ROW" | "%future added value";
export type JiraFormattingMultipleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "HAS_ANY_OF" | "%future added value";
export type JiraFormattingNoValueOperator = "IS_EMPTY" | "IS_NOT_EMPTY" | "%future added value";
export type JiraFormattingSingleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "DOES_NOT_EQUAL" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUALS" | "IS" | "IS_AFTER" | "IS_BEFORE" | "IS_NOT" | "IS_ON_OR_AFTER" | "IS_ON_OR_BEFORE" | "LESS_THAN" | "LESS_THAN_OR_EQUALS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useCellsConditionalFormatting_rules$data = {
  readonly conditionalFormattingRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expression: {
          readonly fieldId?: string;
          readonly multipleValueOperator?: JiraFormattingMultipleValueOperator;
          readonly noValueOperator?: JiraFormattingNoValueOperator;
          readonly singleValueOperator?: JiraFormattingSingleValueOperator;
          readonly value?: string;
          readonly values?: ReadonlyArray<string>;
        };
        readonly formattingArea: JiraFormattingArea;
        readonly formattingColor: {
          readonly colorKey: string | null | undefined;
          readonly id: string | null | undefined;
        };
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCellsConditionalFormatting_rules";
};
export type useCellsConditionalFormatting_rules$key = {
  readonly " $data"?: useCellsConditionalFormatting_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting_rules">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useCellsConditionalFormatting_rules",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "JiraFormattingRuleConnection",
      "kind": "LinkedField",
      "name": "conditionalFormattingRules",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFormattingRuleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraFormattingRule",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "expression",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "singleValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "JiraFormattingSingleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "multipleValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "values"
                        }
                      ],
                      "type": "JiraFormattingMultipleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "noValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        }
                      ],
                      "type": "JiraFormattingNoValueOperand"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "formattingArea"
                },
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "formattingColor",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    }
                  ]
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "conditionalFormattingRules(first:20)"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "4ad11db40961c16bb414c671329a0ed5";

export default node;
